import { Component, OnInit, Output, EventEmitter, } from '@angular/core';
import { faCheck, faInfoCircle, faChevronCircleRight, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { isNullOrEmpty, isNullOrUndefined, isNullOrUndefinedObject } from 'src/app/helper/validation';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../project.service';
import { SharedService } from '../../helper/shared/shared.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { createPopper } from '@popperjs/core';

enum SaveStatus {
  Saving = 'Saving...',
  Saved = 'Saved.',
  Idle = '',
}

function sleep(ms: number): Promise<any> {
  return new Promise((res) => setTimeout(res, ms));
}

@Component({
  selector: 'app-site-info',
  templateUrl: './site-info.component.html',
  styleUrls: ['./site-info.component.scss']
})

export class SiteInfoComponent implements OnInit {
  @Output() nextStep = new EventEmitter<String>();
  faAngleRight = faAngleRight;
  faCheck = faCheck;
  faInfoCircle = faInfoCircle;
  faChevronCircleRight = faChevronCircleRight;
  siteinfo = this.projectService.getSiteInfoEmptyValueStructure();
  flag = false;

  saveStatus: SaveStatus.Saving | SaveStatus.Saved | SaveStatus.Idle = SaveStatus.Idle;
  projectId = this.projectService.projectdetails.projectInfo.id;
  siteInfo:any;

  constructor(
    private projectService : ProjectService,
    private toastr: ToastrService,
    public sharedService : SharedService,
    private formBuilder: FormBuilder,
    private cookieSvc: CookieService
  ) { }


  ngOnInit(): void {
    window.scroll(0, 0);
    this.projectService.activePage = 2;

    this.siteinfo = this.projectService.projectdetails.siteInfo;
    // if(!isNullOrUndefinedObject(this.projectService.projectdetails.siteInfo)) {
    //   this.siteinfo = this.projectService.projectdetails.siteInfo;
    // } else {
    //   this.projectService.projectdetails.siteInfo = this.siteInfo;
    // }
  }

  next() {
    this.nextStep.emit();
  }

  ngOnDestroy() { 
    if (this.projectService.valid['siteInfo'] === 'Skipped') {
      this.projectService.valid['siteInfo'] = '';
    }else{
      this.Proceed();
    }  
     this.sharedService.blnLoadFromRecord = false;
  }

  onMouseClick(e: MouseEvent) {
    if (this.sharedService.clickOnMoreOptionsBtn) {
      var headerMenuClass: any;
      headerMenuClass = document.getElementsByClassName('topbar');
      for (var i=0; i< headerMenuClass.length; i++){
        if (headerMenuClass[i].style.zIndex == '-1') {
          headerMenuClass[i].style.zIndex = '99';
        } else {
          headerMenuClass[i].style.zIndex = '-1';
        }
      }
    }
  }

  skipsection(){
    this.projectService.valid['siteInfo'] = 'Skipped';
    this.next();
  }

  Proceed(){
    this.flag = false;
    if(isNullOrEmpty(this.siteinfo.siteName)) {
      this.flag = true;
    }
    if(this.flag && this.projectService.valid['siteInfo'] !== 'Skipped'){
      //this.toastr.warning('Please key-in Site Name.', 'Warning');
    }
    else{
      this.projectService.projectdetails['siteInfo'] = this.siteinfo;
      this.projectService.valid.siteInfo = 'Valid';
    }
  }


  showHideInfoToggle() {
    let SiteInfo = document.getElementById('SiteInfoBtn');
    let SiteInfoToolTip = document.getElementById('SiteInfo');
    this.createPop(SiteInfo, SiteInfoToolTip);
    if (this.siteInfo) {
      SiteInfoToolTip.removeAttribute("data-show");
      this.siteInfo = false;
    } else {
      SiteInfoToolTip.setAttribute("data-show", "");
      this.siteInfo = true;
    }
  }

  createPop(ref:any, popper:any ) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
         {
           name: "offset",
           options: {
             offset: [0, 8],
           },
         },
      ],
    });
  }

  detectChanges($event:any) {
    let inputname = $event.srcElement.name;
    let inputval = $event.srcElement.value;
    switch (inputname) {
      case "siteName":
        this.siteinfo.siteName = inputval;
        break;
      case "location":  
        this.siteinfo.location = inputval;
        break;
      case "building": 
        this.siteinfo.building = inputval;
        break;
      case "room":
        this.siteinfo.room = inputval;
        break;
      case "ahu":
        this.siteinfo.ahu = inputval;
        break;
      case "desc":  
        this.siteinfo.siteDesc = inputval;
        break;
    }
    this.projectService.projectdetails.siteInfo = this.siteinfo;
  }

}
